import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./footer.css";
import { useTranslation, withTranslation } from "react-i18next";
import { getImage } from "../../components/GenericComponents/functions";
import Popup from "../../components/cmpPopup/cmpPopup";
import Policy from "../../components/cmpPolicy/cmpPolicy";
import Sitemap from "../../components/cmpSitemap/cmpSitemap";
import Cookies from "../../components/cmpCookies/cmpCookies";

const Footer: React.FC = () => {
    const { t } = useTranslation();
    const infoPolicy:any = t("policy", { returnObjects: true });
    const infoRefund:any = t("refund", { returnObjects: true });
    const footer = t("footer.content", { returnObjects: true });
    const copyright = t("footer.copyright", { returnObjects: true });
    const infoMenus:any = t("menu", { returnObjects: true }); 

    const copyright_details: any = copyright;
    const data: any[] = []; 
    if (Array.isArray(footer)) { footer.forEach(el => {data.push(el)}) }

    const [isOpenSitemap, setIsOpenSitemap] = useState(false);
    const [isOpenPolicy, setIsOpenPolicy] = useState(false); 
    const [isOpenRefund, setIsOpenRefund] = useState(false); 
    const [isOpenCookies, setIsOpenCookies] = useState(false);

    const togglePopupSitemap = () => { setIsOpenSitemap(!isOpenSitemap) };
    const togglePopupPolicy = () => { setIsOpenPolicy(!isOpenPolicy) };
    const togglePopupRefund = () => { setIsOpenRefund(!isOpenRefund) };
    const togglePopupCookies = () => { setIsOpenCookies(!isOpenCookies) };

    return (
        <div className="footer">
            <div className="footer_image"></div>
            <div className="whole_footer_details">
                <div className="footer_details_container">
                    {/* details */}
                    <div className="footer_details">
                        {/* first col */}
                        <div className="footer_first_col">
                            <p className="footer_first_row_header">{data[0]?.label}</p>

                            <div className="footer_first_row_details">
                                {data[0]?.content.map((item: any, i: number) => (
                                    <Link 
                                        key={`first-col-item-${i}`} 
                                        className="footer_first_row_links" 
                                        to={item?.navigateTo}
                                    >
                                        <div className="footer_first_row_details_square"></div>
                                        {item?.label}
                                    </Link>
                                ))}
                            </div>
                        </div>

                        {/* second col */}
                        <div className="footer_second_col">
                            <p className="footer_first_row_header">{data[1]?.label}</p>

                            <div className="footer_second_row_details">
                                <div className="footer_second_row_addresses">
                                    {data[1]?.content.slice(0, 3).map((item: any, i: number) => (
                                        <p key={`second-col-address-${i}`} className="footer_second_row_details_address">
                                            {item?.label}
                                        </p>
                                    ))}
                                </div>

                                {data[1]?.content.slice(3, 5).map((item: any, i: number) => (
                                    <a 
                                        key={`second-col-tel-${i}`} 
                                        href={`tel:${item?.label}`} 
                                        className='footer_second_row_details_tel'
                                    >
                                        {item?.label}
                                    </a>
                                ))}

                                {data[1]?.content[5] && (
                                    <a 
                                        key={`second-col-email-${data[1]?.content[5]?.label}`} 
                                        href={`mailto:${data[1]?.content[5]?.label}`} 
                                        className="footer_second_row_details_email"
                                    >
                                        {data[1]?.content[5]?.label}
                                    </a>
                                )}
                            </div>
                        </div>

                        {/* third col */}
                        <div className="footer_third_col">
                            <div className="footer_third_row_header">
                                <div className="footer_third_row_icons">
                                    {data[2]?.content[0]?.content.map((item: any, i: number) => (
                                        <img key={`icon-${i}`} className="footer_icon" src={getImage(item?.src)} alt="" />
                                    ))}
                                </div>
                                <div className="footer-line"></div>
                            </div>

                            <div className="footer_third_row_details">
                                {data[2]?.content.slice(1).map((item: any, i: number) => {
                                    switch (item.id.toLowerCase()) {
                                        case "sitemap":
                                            return (
                                                <div key={`sitemap-${i}`}>
                                                    <div
                                                        className="footer_first_row_links" 
                                                        onClick={togglePopupSitemap}
                                                    >
                                                        <div className="footer_first_row_details_square"></div>
                                                        {item?.label}
                                                    </div>
                                                    {isOpenSitemap && ( 
                                                        <Popup 
                                                            content={
                                                                <Sitemap 
                                                                    card={infoMenus}  
                                                                    onClick={togglePopupSitemap}
                                                                />
                                                            }
                                                            type="policy"
                                                            popupOptions={undefined}
                                                            handleClose={togglePopupSitemap}
                                                        />
                                                    )}
                                                </div>
                                            );

                                        case "policy":
                                            return (
                                                <div key={`policy-${i}`}>
                                                    <div 
                                                        className="footer_first_row_links" 
                                                        onClick={togglePopupPolicy}
                                                    >
                                                        <div className="footer_first_row_details_square"></div>
                                                        {item?.label}
                                                    </div>
                                                    {isOpenPolicy && ( 
                                                        <Popup 
                                                            content={
                                                                <Policy 
                                                                    card={infoPolicy} 
                                                                />
                                                            }
                                                            type="policy"
                                                            popupOptions={undefined}
                                                            handleClose={togglePopupPolicy}
                                                        />
                                                    )}
                                                </div>
                                            );

                                            case "refund":
                                                return (
                                                    <div key={`refund-${i}`}>
                                                        <div 
                                                            className="footer_first_row_links" 
                                                            onClick={togglePopupRefund}
                                                        >
                                                            <div className="footer_first_row_details_square"></div>
                                                            {item?.label}
                                                        </div>
                                                        {isOpenRefund && ( 
                                                            <Popup 
                                                                content={
                                                                    <Policy 
                                                                        card={infoRefund} 
                                                                    />
                                                                }
                                                                type="refund"
                                                                popupOptions={undefined}
                                                                handleClose={togglePopupRefund}
                                                            />
                                                        )}
                                                    </div>
                                                );                                            
                                        
                                        case "cookies":
                                            return (
                                                <div key={`cookies-${i}`}>
                                                    <div
                                                        className="footer_first_row_links" 
                                                        onClick={togglePopupCookies}
                                                    >
                                                        <div className="footer_first_row_details_square"></div>
                                                        {item?.label}
                                                    </div>
                                                    {/*
                                                    {isOpenCookies && ( 
                                                        <Popup 
                                                            content={
                                                                <Cookies 
                                                                    card={""}  // Pending to complete
                                                                />
                                                            }
                                                            type="policy"
                                                            popupOptions={undefined}
                                                            handleClose={togglePopupCookies}
                                                        />
                                                    )}
                                                        */}
                                                </div>
                                            );

                                        default:
                                            return (
                                                <Link 
                                                    key={`default-${i}`} 
                                                    className="footer_first_row_links" 
                                                    to={item?.navigateTo}
                                                >
                                                    <div className="footer_first_row_details_square"></div>
                                                    {item?.label}
                                                </Link>
                                            );
                                    }
                                })}
                            </div>
                        </div>
                    </div>

                    {/* copyright */}
                    <div className="copyright" dangerouslySetInnerHTML={{__html: copyright_details}}></div>
                </div>
            </div>
        </div>
    );
};

export default withTranslation('translation', { withRef: true }) (Footer);
